import React from 'react';
import '../../styles/fight/SelectionCarousel.scss';

const SelectionCarousel = ({ carouselItems = [], selectedIndex = 0, onSelect, isSubHeader = false }) => {
  return (
    <div className='selection-carousel'>
      {carouselItems.map((item, index) => (
        <button
          key={item}
          type='button'
          className={`carousel-item ${selectedIndex === index ? 'selected' : ''} ${isSubHeader ? 'sub-header' : ''}`}
          onClick={() => onSelect?.(index)}>
          <span className='item-text'>
            {typeof item === 'string' ? item : item.label || item.name || `Item ${index + 1}`}
          </span>
        </button>
      ))}
    </div>
  );
};

export default SelectionCarousel;
